export default class BlockBanner {
	static init() {

		let banner = document.querySelector('.banner');
		if( !banner ){
			return;
		}
		const swiper = banner.querySelector('.banner-slider');
		if( !swiper ){
			return;
		}
		const navigation = banner.querySelector('.swiper-navigation');

		const prev = swiper.querySelector(".banner-button-prev");
		const next = swiper.querySelector(".banner-button-next");

		let options = {
			slidesPerView: "1",
			effect: 'fade',
			allowTouchMove: false,
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: navigation,
				type: 'bullets',
				bulletElement: 'span',
				clickable: true
			},
			navigation: {
				prevEl: prev,
				nextEl: next,
			},
			on: {
				'init' : (slider) => {
					let slide = slider.slides[0];
					if(slide){
						let movie = slide.querySelector('video');
						if( movie ) {
							movie.play();
						}
					}
				},
				'slideChangeTransitionEnd': (slider)=> {

					slider.slides.forEach((slide) => {
						let movie = slide.querySelector('video');
						if( movie && slide.classList.contains('swiper-slide-active') ){
							movie.play();
						}else if( movie ){
							movie.pause();
						}
					});

				}
			}
		};

		if( swiper.querySelectorAll('.swiper-slide').length > 1 ){
			options.loop = true;
			options.grabCursor = true;
			options.allowTouchMove = true;
		}

		new Swiper(swiper, options);

	}
}
